import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, vShow as _vShow, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_FormComponent = _resolveComponent("FormComponent")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          class: "filter-item",
          type: "primary",
          size: _ctx.t('table.btnSize'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCommand('add')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
          ]),
          _: 1
        }, 8, ["size"])), [
          [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
        dataList: _ctx.list,
        total: _ctx.total,
        columnAllData: _ctx.columnAllData,
        page: _ctx.listQuery.page,
        size: _ctx.listQuery.size,
        tableName: _ctx.TableName.TABLE_FEE_RATE,
        permissionName: _ctx.permissionName,
        onCommandChange: _ctx.handleCommand,
        "can-change-column": false,
        "can-refresh": false
      }, {
        "operation-action": _withCtx((scope) => [
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            class: "mr-10",
            type: "primary",
            onClick: ($event: any) => (_ctx.handleCommand('edit', scope.row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.edit")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_EDIT` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
            href: "javascript:void(0);",
            type: "danger",
            onClick: ($event: any) => (_ctx.handleCommand('delete', scope.row))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("table.delete")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_DELETE` }]
          ])
        ]),
        _: 1
      }, 8, ["dataList", "total", "columnAllData", "page", "size", "tableName", "permissionName", "onCommandChange"])), [
        [_directive_loading, _ctx.listLoading]
      ])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dialogFormVisible)
      ? (_openBlock(), _createBlock(_component_FormComponent, {
          key: 0,
          id: _ctx.activeId,
          initFormData: _ctx.initFormData,
          fromFieldData: _ctx.fromFieldData,
          dialogFormVisible: _ctx.dialogFormVisible,
          api: _ctx.pathApi,
          "onUpdate:visibel": _cache[1] || (_cache[1] = () => _ctx.dialogFormVisible = false),
          onSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSubmit(_ctx.formData)))
        }, null, 8, ["id", "initFormData", "fromFieldData", "dialogFormVisible", "api"]))
      : _createCommentVNode("", true)
  ]))
}